function CalculatorInputsToFill({
  handleProductSelectChange,
  products,
  handlePrevisionSelectChange,
  previsions,
  containers,
  handleContainerSelectChange,
  dollarPrice,
  setDollarPrice,
  chinaPrice,
  setChinaPrice,
  targetPrice,
  setTargetPrice,
  landFreightPrice,
  setLandFreightPrice,
}) {
  return (
    <div className="flex flex-col gap-4 p-4 bg-gray-50 rounded-lg shadow-md">
      <div className="flex items-center gap-4">
        <label className="w-40 text-gray-700 font-semibold">Produto</label>
        <select
          onChange={handleProductSelectChange}
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
        >
          <option>Selecione um produto</option>
          {products.map((product) => {
            return (
              <option key={product.id} value={product.id}>
                {product.name}
              </option>
            );
          })}
        </select>
      </div>
      <div className="flex items-center gap-4">
        <label className="w-40 text-gray-700 font-semibold">Previsão</label>
        <select
          onChange={handlePrevisionSelectChange}
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
        >
          <option>Selecione um produto</option>
          {previsions.map((prevision) => {
            return (
              <option key={prevision.id} value={prevision.id}>
                {prevision.name_previsions}
              </option>
            );
          })}
        </select>
      </div>
      {[
        {
          label: "Preço China $",
          type: "number",
          value: chinaPrice,
          onchange: setChinaPrice,
        },
        {
          label: "Preço Alvo $",
          type: "number",
          value: targetPrice,
          onchange: setTargetPrice,
        },

        {
          label: "Dólar R$",
          type: "number",
          value: dollarPrice,
          onchange: setDollarPrice,
        },
      ].map((field, index) => (
        <div key={index} className="flex items-center gap-4">
          <label className="w-40 text-gray-700 font-semibold">
            {field.label}
          </label>
          <input
            type={field.type}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            step={0.01}
            required
            value={field.value ?? ""}
            onChange={(e) => field.onchange && field.onchange(e.target.value)}
          />
        </div>
      ))}

      <div className="flex items-center gap-4">
        <label className="w-40 text-gray-700 font-semibold">Container</label>
        <select
          onChange={handleContainerSelectChange}
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
        >
          <option>Selecione um Contêiner</option>
          {containers.map((container) => {
            return (
              <option key={container.id} value={container.id}>
                {container.type_container}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
}

export default CalculatorInputsToFill;
